import { Table } from 'antd';
import styled from 'styled-components';

export const ModalTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #31394d;
`;

export const Title = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #748aa1;
`;

export const TypologiesTable = styled(Table)`
  margin-top: 6px;

  .ant-table .ant-table-container table .ant-table-tbody .ant-table-cell {
    font-size: 12px;
    line-height: 20px;
    color: #31394d;
    padding: 6px 26px;
    box-shadow: inset 0px 1px 1px #d0d7e3, inset 0px -1px 1px #d0d7e3,
      inset 1px 0px 1px #d0d7e3, inset -1px 0px 1px #d0d7e3;
  }
`;
